export default __webpack_public_path__ + "static/media/romao.40c58db9.jpg";